
























































import { PropType } from 'vue';
import { mapActions } from 'vuex';

import { ContractStateEnum, IContract } from '@/models';
import { ISystemError } from '@/models/error/error.types';

import { setErrorFromAxiosError } from '@/utils/helpers';

import auth from '@/mixins/auth';
import mixins from '@/utils/mixins';

import ConfirmationDialog from '@/components/common/ConfirmationDialog.vue';

export default mixins(auth).extend({
  name: 'ContractUndoExecuteStateButton',

  components: {
    ConfirmationDialog
  },

  props: {
    contract: {
      type: Object as PropType<IContract>
    }
  },

  data() {
    return {
      error: null as ISystemError | null,

      isStateTransitioning: false,
      isDialogActive: false
    };
  },

  methods: {
    ...mapActions({
      updateContractState: 'contract/updateContractState'
    }),

    clearErrors() {
      this.error = null;
    },

    closeDialog() {
      this.isDialogActive = false;
    },

    changeState(state: ContractStateEnum) {
      this.clearErrors();
      this.isStateTransitioning = true;
      this.updateContractState({
        contractId: this.contract.id,
        state: state
      })
        .then(() => {
          this.closeDialog;
        })
        .catch(error => {
          this.error = setErrorFromAxiosError(error);
        })
        .finally(() => {
          this.isStateTransitioning = false;
        });
    },

    undoExecuteContract() {
      this.changeState(ContractStateEnum.Draft);
    }
  }
});
